<template>
    <div class="pop_up_layer com_pop" style="display: block" @click="closeModal"></div>
    <div class="pop_up com_pop" style="display: block">
        <div class="pop_tit _flex">
            <p>반성매매 시민활동 {{ state.idx === 0 ? "등록" : "수정" }}</p>
            <button class="close_btn icon_wrap" @click="closeModal">
                <img src="img/close.png" alt="닫기" />
            </button>
        </div>

        <div class="sign_form custom_scroll">
            <ul>
                <li :class="{ imp: state.mode }">
                    <label for="title" class="form_li_tit">제목</label>
                    <input id="title" type="text" v-model="state.data.title" />
                </li>
                <li :class="{ imp: state.mode }">
                    <label for="duration" class="form_li_tit">활동기간</label>
                    <div class="select_date_wrap">
                        <div class="select_date">
                            <input type="date" name="" id="" v-model="form_state.activeStartDate" />
                        </div>
                        <div class="select_date">
                            <input type="date" name="" id="" v-model="form_state.activeEndDate" />
                        </div>
                    </div>
                </li>
                <li :class="{ imp: state.mode }">
                    <label for="duration" class="form_li_tit">모집기간</label>
                    <div class="select_date_wrap">
                        <div class="select_date">
                            <input type="date" name="" id="" v-model="form_state.recruitStartDate" />
                        </div>
                        <div class="select_date">
                            <input type="date" name="" id="" v-model="form_state.recruitEndDate" />
                        </div>
                    </div>
                </li>
                <li :class="{ imp: state.mode }">
                    <label for="title" class="form_li_tit">모집인원</label>
                    <div style="display: flex; align-items: center">
                        <input id="title" type="text" v-model="state.data.cntApply" />
                        <span style="font-weight: 500; color: #000; font-size: 100%; display: inline-block">명</span>
                    </div>
                </li>

                <li :class="{ imp: state.mode }">
                    <label for="duration" class="form_li_tit">신청 종료일</label>
                    <div class="select_date_wrap">
                        <div class="select_date">
                            <input type="date" @keydown.enter="" name="" id="" v-model="form_state.applyDate" />
                        </div>
                    </div>
                </li>
                <li :class="{ imp: state.mode }">
                    <label for="area_address" class="form_li_tit">주소</label>
                    <div style="display: flex">
                        <input
                            type="text"
                            id="area_address"
                            readonly
                            class="code _blocked"
                            v-model="form_state.zipCode"
                            placeholder="우편번호"
                            @click="searchAddress"
                        />
                        <button class="blue_btn w_120" @click="searchAddress" style="width: 80px; margin-left: 10px">검색</button>
                    </div>
                    <div style="margin-left: 110px">
                        <input
                            style="margin-top: 10px"
                            type="text"
                            id="area_address"
                            readonly
                            class="text _blocked"
                            v-model="form_state.address"
                            placeholder="주소"
                        />
                        <input style="margin-top: 10px" type="text" id="area_address2" v-model="form_state.addressDetail" placeholder="상세주소" />
                    </div>
                </li>
                <li class="li_con" :class="{ imp: state.mode }">
                    <label for="editor1" class="form_li_tit" aria-placeholder="내용을 입력해주세요.">내용</label>
                    <textarea id="editor1" name="editor1" class="custom_scroll" v-model="state.data.content"></textarea>
                </li>
                <li class="li_con" :class="{ imp: state.mode }">
                    <label for="editor2" class="form_li_tit" aria-placeholder="개인정보 동의 문구를 입력해주세요.">
                        개인정보 수집
                        <br />
                        및 이용 동의
                    </label>
                    <textarea id="editor2" name="editor2" class="custom_scroll" v-model="state.data.term"></textarea>
                </li>
                <li class="file_wrap">
                    <span class="form_li_tit">첨부</span>
                    <label for="area_file">
                        <input id="area_file" type="file" placeholder="" accept="image/*" multiple @change="handleFiles" />
                        <div class="file_box_wrap">‘파일첨부’ 버튼을 클릭하거나 파일을 드래그하여 첨부해주세요</div>
                        <span class="blue_btn" style="display: flex; justify-content: center; align-items: center">파일첨부</span>
                        <p class="p_info">200M 이하 JPG, PNG 파일을 첨부해주세요.</p>
                    </label>
                    <div class="file_list">
                        <div class="file" v-for="(item, idx) in state.data.fileList" :key="idx">
                            <span class="file_name">{{ item.imgRealName }}</span>
                            <button class="file_del icon_wrap" @click="fileRemove(item.idx)">
                                <img src="img/close_02.png" alt="" />
                            </button>
                        </div>

                        <div class="file" v-for="(item, index) in state.file" :key="index">
                            <span class="file_name">{{ item.name }}</span>
                            <button class="file_del icon_wrap" @click="removeFile(index)">
                                <img src="img/close_02.png" alt="" />
                            </button>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <div class="_flex _center btn_wrap">
            <button class="submit_btn _130 _main_blue" @click="save" v-text="state.mode ? '등록' : '수정'"></button>
        </div>
    </div>

    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="state.isShowModal = false"
        @callback="callBackModal"
    ></ModalDefault>
</template>
<script lang="ts">
    import {
        onMounted,
        reactive,
        watch,
        onUnmounted,
        CommonUtils,
        apiService,
        types,
        getMessageByCode,
        CkEditorManager,
        ModalDefault,
    } from "@/BaseComponent";

    export default {
        props: {
            data: {
                type: Object,
                defalut: {},
            },
        },
        emits: ["close", "callback"],
        components: { ModalDefault },
        setup(props: any, { emit }: any) {
            const state = reactive({
                idx: 0 as number,
                data: {} as any,
                file: [] as Array<File>,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,

                mode: true as boolean, // true: add, false: modify
            });

            const form_state = reactive({
                activeStartDate: "",
                activeEndDate: "",
                recruitStartDate: "",
                recruitEndDate: "",
                zipCode: "",
                address: "",
                addressDetail: "",
                applyDate: "" as string,
            });

            let editorManager: CkEditorManager | null = null;
            let editorManagerTerm: CkEditorManager | null = null;

            onMounted(async () => {
                if (props.data) {
                    state.data = props.data;
                    state.idx = state.data.idx;
                    form_state.applyDate = CommonUtils.dateFormat(state.data.applyDate, "-", false);
                    form_state.activeStartDate = CommonUtils.dateFormat(state.data.activeStartDate, "-", false);
                    form_state.activeEndDate = CommonUtils.dateFormat(state.data.activeEndDate, "-", false);
                    form_state.recruitStartDate = CommonUtils.dateFormat(state.data.recruitStartDate, "-", false);
                    form_state.recruitEndDate = CommonUtils.dateFormat(state.data.recruitEndDate, "-", false);

                    form_state.zipCode = state.data.zipCode;
                    form_state.address = state.data.address;
                    form_state.addressDetail = state.data.addressDetail;

                    state.mode = false;
                } else {
                    state.data = {};
                    state.idx = 0;
                    form_state.applyDate = "";
                    form_state.activeStartDate = "";
                    form_state.activeEndDate = "";
                    form_state.recruitStartDate = "";
                    form_state.recruitEndDate = "";
                    form_state.zipCode = "";
                    form_state.address = "";
                    form_state.addressDetail = "";

                    state.mode = true;
                }

                editorManager = new CkEditorManager("editor1", state.data, "suggestion");
                await editorManager.initEditor();
                editorManager?.setDataInfo(state.data.content);

                const term = { content: state.data.term };
                editorManagerTerm = new CkEditorManager("editor2", term, "suggestion");
                await editorManagerTerm.initEditor();
                editorManagerTerm?.setDataInfo(state.data.term);
            });

            onUnmounted(() => {
                editorManager?.destroy();
            });

            watch(props, async () => {
                if (props.data) {
                    state.data = props.data;
                    state.idx = state.data.idx;
                    form_state.applyDate = CommonUtils.dateFormat(state.data.applyDate, "-", false);
                    form_state.activeStartDate = CommonUtils.dateFormat(state.data.activeStartDate, "-", false);
                    form_state.activeEndDate = CommonUtils.dateFormat(state.data.activeEndDate, "-", false);
                    form_state.recruitStartDate = CommonUtils.dateFormat(state.data.recruitStartDate, "-", false);
                    form_state.recruitEndDate = CommonUtils.dateFormat(state.data.recruitEndDate, "-", false);

                    form_state.zipCode = state.data.zipCode;
                    form_state.address = state.data.address;
                    form_state.addressDetail = state.data.addressDetail;

                    state.mode = false;
                } else {
                    state.data = {};
                    state.idx = 0;
                    form_state.applyDate = "";
                    form_state.activeStartDate = "";
                    form_state.activeEndDate = "";
                    form_state.recruitStartDate = "";
                    form_state.recruitEndDate = "";
                    form_state.zipCode = "";
                    form_state.address = "";
                    form_state.addressDetail = "";

                    state.mode = true;
                }

                editorManager = new CkEditorManager("editor1", state.data, "suggestion");
                await editorManager.initEditor();

                editorManager?.setDataInfo(state.data.content);
            });

            const closeModal = () => emit("close");
            const callBackModal = async (param: any) => {
                if (param.action === "callback") {
                    emit("callback");
                } else {
                    state.isShowModal = false;
                }
            };

            const save = async () => {
                if (!state.data.title) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "제목을 입력해주세요.";
                    state.isShowModal = true;
                } else if (!state.data.content) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "내용을 입력해주세요.";
                    state.isShowModal = true;
                } else if (!form_state.activeStartDate || !form_state.activeEndDate) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "활동기간을 선택해주세요.";
                    state.isShowModal = true;
                } else if (!form_state.recruitStartDate || !form_state.recruitEndDate) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "모집기간을 선택해주세요.";
                    state.isShowModal = true;
                } else if (!form_state.applyDate) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "신청 종료일을 선택해주세요.";
                    state.isShowModal = true;
                } else if (!form_state.zipCode || !form_state.address) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "주소를 입력해주세요.";
                    state.isShowModal = true;
                } else if (!((await editorManagerTerm?.getData()) + "")) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "개인정보 수집 및 이용 동의 내용을 입력해주세요";
                    state.isShowModal = true;
                } else {
                    if (state.mode) {
                        const param: types.ReqBoardForActivity = {
                            title: state.data.title,
                            content: (await editorManager?.getData()) + "",
                            term: (await editorManagerTerm?.getData()) + "",
                            activityStartDate: form_state.activeStartDate,
                            activityEndDate: form_state.activeEndDate,
                            recruitmentStartDate: form_state.recruitStartDate,
                            recruitmentEndDate: form_state.recruitEndDate,
                            cntMember: state.data.cntApply,
                            endDate: form_state.applyDate,
                            zipCode: form_state.zipCode,
                            address: form_state.address,
                            addressDetail: form_state.addressDetail,
                            file: state.file,
                        };

                        const res = await apiService.board.addForActivity(param);

                        if (res.returnCode === 0) {
                            state.modalTab = 7;
                            state.modalTitle = "안내";
                            state.modalContent = "등록이 완료되었습니다.";
                            state.isShowModal = true;
                        } else {
                            console.error(res.description);
                            state.modalTab = -1;
                            state.modalTitle = "안내";
                            state.modalContent = getMessageByCode(res.returnCode);
                            state.isShowModal = true;
                        }
                    } else {
                        const param: types.ReqBoardForActivityForModify = {
                            idx: state.data.idx,
                            title: state.data.title,
                            content: (await editorManager?.getData()) + "",
                            term: (await editorManagerTerm?.getData()) + "",
                            activityStartDate: form_state.activeStartDate,
                            activityEndDate: form_state.activeEndDate,
                            recruitmentStartDate: form_state.recruitStartDate,
                            recruitmentEndDate: form_state.recruitEndDate,
                            cntApply: state.data.cntApply,
                            endDate: form_state.applyDate,
                            zipCode: form_state.zipCode,
                            address: form_state.address,
                            addressDetail: form_state.addressDetail,
                            file: state.file,
                        };

                        const res = await apiService.board.modifyForActivity(state.idx, param);

                        if (res.returnCode === 0) {
                            state.modalTab = 7;
                            state.modalTitle = "안내";
                            state.modalContent = "수정이 완료되었습니다.";
                            state.isShowModal = true;
                        } else {
                            console.error(res.description);
                            state.modalTab = -1;
                            state.modalTitle = "안내";
                            state.modalContent = getMessageByCode(res.returnCode);
                            state.isShowModal = true;
                        }
                    }
                }
            };

            const removeFile = (index: number) => state.file.splice(index, 1);

            const handleFiles = (e: any) => {
                const target = e.target as HTMLInputElement;
                const file = e.target.files[0];
                if (!file) return;

                if (!file.type.startsWith("image/")) {
                    e.target.value = "";
                    return;
                }
                state.file = Array.from(e.target.files);
                target.value = "";
            };

            const fileRemove = async (idxFile: number) => {
                const res = await apiService.board.removeFile(state.data.idx, idxFile);
                if (res.returnCode === 0) {
                    const index = state.data.fileList.findIndex((item: any) => item.idx === idxFile);
                    if (index !== -1) {
                        state.data.fileList.splice(index, 1);
                    }
                }
            };

            const searchAddress = async () => {
                new window.daum.Postcode({
                    oncomplete: (data: any) => {
                        form_state.zipCode = data.zonecode;
                        form_state.address = data.address;
                    },
                }).open();
            };

            return { state, closeModal, callBackModal, CommonUtils, searchAddress, save, handleFiles, form_state, removeFile, fileRemove };
        },
    };
</script>

<style scoped>
    .pop_up.com_pop {
        height: 100%;
    }
    .sign_form.custom_scroll {
        height: 85%;
    }
</style>
